<template>
  <div class="h-100 d-flex flex-column">
    <div class="
        justify-content-md-center
        p-3
        d-flex
        flex-column
        justify-content-between
        h-100
      " :style="userData.isAndroid ? '' : 'overflow-y: scroll;'">
      <div>
        <!-- Imaage -->
        <div class="row">
          <div class="col-md-4 justify-content-center align-self-center">
            <div class="">
              <div class="row" style="">
                <div class="
                    offset-2
                    col-8
                    offset-md-1
                    col-md-10
                    justify-content-center
                    align-self-center
                  ">
                  <template>
                    <b-img-lazy center class="image" :src="imgBgNEXT" width="172" height="120" />
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="justify-content-center">
          <b-row v-if="haveDocRequire().length > 0">
            <b-col class="text-ktb-bold-16 mb-2"> {{ "เอกสารที่จำเป็น" }} </b-col>
          </b-row>

          <div class="mb-3 justify-content-md-center" v-for="(item, key) in haveDocRequire()" :key="key">
            <div v-if="!item.deviate_flag">
              <b-card class="border-radius-1rem" body-class="body-landing py-3" @click="doDetail(item.doc_code)">
                <b-row>
                  <b-col class="text-ktb-regular-16">{{
                    item.doc_short_name
                  }}</b-col>
                  <b-col cols="1" class="px-0">
                    <b-img width="24" height="24" style="cursor: pointer" :src="imgArrowRight"></b-img>
                  </b-col>
                </b-row>
                <div v-if="item.filesReal.length > 0">
                  <hr />
                  <b-row class="pt-1">
                    <b-col v-if="item.state == 'attachfile'">
                      <span class="text-ktb-regular-org">รออัปโหลด {{ item.filesReal.length }} ไฟล์
                      </span>
                    </b-col>
                    <b-col v-else-if="item.state == 'success'">
                      <span class="text-ktb-regular-16-green">อัปโหลดสำเร็จ {{ item.filesReal.length }} ไฟล์
                      </span>
                    </b-col>
                    <b-col v-else>
                      <span class="text-ktb-regular-16-red">อัปโหลดไม่สำเร็จ {{ item.filesReal.length }} ไฟล์
                      </span>
                    </b-col>
                    <b-col v-if="item.state == 'attachfile'">
                      <span style="float: right" class="text-ktb-regular-16-grey">{{
                        getSizeFileUploadsMB(item.filesReal) }} MB
                      </span></b-col>
                  </b-row>
                </div>
                <div v-else-if="
                  'RESUBMIT' === userData.followupStatus.code &&
                  userData.historyUploads.find(
                    (i) => i.doc_code == item.doc_code
                  ).doc_upload_date !== null
                ">
                  <hr />
                  <b-row class="pt-1">
                    <b-col v-if="item.state == 'wait'">
                      <span class="text-ktb-regular-16-red">กรุณาอัปโหลดเอกสารใหม่
                      </span>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </div>
          </div>
        </div>
        <div>
          <div class="justify-content-center mt-3">
            <b-row v-if="haveDocDeviate().length > 0">
              <b-col class="text-ktb-bold-16 mb-2"> {{ "เอกสารเพิ่มเติม" }} </b-col>
            </b-row>

            <div>
              <div class="mb-3 justify-content-md-center" v-for="(item, key) in haveDocDeviate()" :key="key">
                <div v-if="item.deviate_flag">
                  <b-card class="border-radius-1rem" body-class="body-landing py-3" @click="doDetail(item.doc_code)">
                    <b-row class="">
                      <b-col class="text-ktb-regular-16">{{
                        item.doc_short_name
                      }}</b-col>
                      <b-col cols="1" class="px-0">
                        <b-img width="24" height="24" style="cursor: pointer" :src="imgArrowRight"></b-img>
                      </b-col>
                    </b-row>
                    <div v-if="item.filesReal.length > 0">
                      <hr />
                      <b-row class="pt-1">
                        <b-col v-if="item.state == 'attachfile'">
                          <span class="text-ktb-regular-org">รออัปโหลด {{ item.filesReal.length }} ไฟล์
                          </span>
                        </b-col>
                        <b-col v-else-if="item.state == 'success'">
                          <span class="text-ktb-regular-16-green">อัปโหลดสำเร็จ {{ item.filesReal.length }} ไฟล์
                          </span>
                        </b-col>
                        <b-col v-else>
                          <span class="text-ktb-regular-16-red">อัปโหลดไม่สำเร็จ {{ item.filesReal.length }} ไฟล์
                          </span>
                        </b-col>
                        <b-col v-if="item.state == 'attachfile'">
                          <span style="float: right" class="text-ktb-bold-16-grey">{{
                            getSizeFileUploadsMB(item.filesReal) }} MB
                          </span></b-col>
                      </b-row>
                    </div>
                    <div v-else-if="
                      'RESUBMIT' === userData.followupStatus.code &&
                      userData.historyUploads.find(
                        (i) => i.doc_code == item.doc_code
                      ).doc_upload_date !== null
                    ">
                      <hr />
                      <b-row class="pt-1">
                        <b-col v-if="item.state == 'wait'">
                          <span class="text-ktb-regular-16-red">กรุณาอัปโหลดเอกสารใหม่
                          </span>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card>
                </div>
              </div>
            </div>
          </div>

          <div class="justify-content-center" v-if="haveDocDeviate().length > 0">
            <div class="mt-3 justify-content-md-center">
              <b-card class="border-radius-1rem mt-2" body-class="py-1 mb-2">
                <b-row class="pt-1">
                  <b-col class="col-2 py-2">
                    <img class="image" :src="imgVayu" width="32" height="32" />
                  </b-col>
                  <b-col>
                    <span class="text-ktb-regular">เอกสารเพิ่มเติมจะช่วยเพิ่มโอกาสในการพิจารณาสินเชื่อ
                    </span>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </div>
        </div>
      </div>

      <div v-if="userData.isDocumentType">
        <b-row class="mt-4">
          <b-col>
            <button :class="'btn btn-info rounded-pill btn-block font-weight-bold btn-ktb btn-submit btn-ktb-' +
              userData.channel
              " @click="doBack()" :disabled="!checkFileRequire()">
              <template> ถัดไป </template>
            </button>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgBgNEXT: require("@/assets/images/Upload Documents@3x.png"),
      imgVayu: require("@/assets/images/foundationIllustrationMiscVayuInformation@3x.png"),
      imgArrowRight: require("@/assets/images/foundationIconSimpleSystemArrowRight@3x.png"),
      docList: [],
      userData: {},
      size: 0,
      files: [],
      realFiles: [],
      listDoc: [],
      grpId: null,
    };
  },
  created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    this.userData = this.$store.getters.getUserData;
    this.grpId = this.userData.grpId;
    let currentMenu = {
      pageCode: "CommonPreUpload",
      pageName: this.userData.document_group_type.find(
        (i) => i.grp_id == this.grpId
      ).grp_name,
      previousPage: this.userData.routerPath.landing,
    };
    this.$event.$emit("update_current_menu", currentMenu);

    if (!this.userData.token)
      this.$router.push(this.userData.routerPath.landing);
  },
  mounted() {
    this.initData();
    //Order Display
    if (this.files.filter((item) => !item.deviate_flag).length > 0)
      this.GroupDocDisplay.push(
        this.files.filter((item) => !item.deviate_flag)
      );
    if (this.files.filter((item) => item.deviate_flag).length > 0)
      this.GroupDocDisplay.push(this.files.filter((item) => item.deviate_flag));
  },
  methods: {
    initData() {
      this.listDoc = this.userData.document_group_type.find(
        (v) => v.grp_id == this.grpId
      );

      for (var i = 0; i < this.listDoc.lst_doc_id.length; i++) {
        for (var j = 0; j < this.userData.documentType.length; j++) {
          if (
            this.userData.documentType[j].doc_code == this.listDoc.lst_doc_id[i]
          ) {
            this.docList.push(this.userData.documentType[j]);
          }
        }
      }
      if (this.docList.length == 1 && this.docList[0].state != "deviate") {
        if (this.$route.params.action == "NEXT") {
          this.doDetail(this.docList[0].doc_code);
        } else {
          this.$router.push({
            name: this.userData.routerPath.landing,
          });
        }
      }
    },
    doBack() {
      this.$router.push({
        name: this.userData.routerPath.landing,
      });
    },
    getHeader() {
      return this.listDoc.grp_name;
    },
    doDetail(doc_code) {
      this.$router.push({
        name: this.userData.routerPath.upload,
        params: { doc_code: doc_code, grpId: this.grpId },
      });
    },
    getListFileByType() {
      return this.realFiles;
    },
    cancel() {
      this.$router.push(this.userData.routerPath.landing);
    },
    haveDocRequire() {
      return this.docList.filter(
        (item) => !item.deviate_flag && item.state != "deviate"
      );
    },
    haveDocDeviate() {
      return this.docList.filter(
        (item) => item.deviate_flag && item.state != "deviate"
      );
    },
    checkFileRequire() {
      let check = 0;
      this.docList.forEach((v) => {
        if (!v.deviate_flag && v.filesReal.length != 0) {
          check++;
        }
      });

      return this.docList.filter((v) => !v.deviate_flag).length == check;
    },
    getHistory(doc_code) {
      return this.userData.historyUploads.find((i) => i.doc_code == doc_code);
    },
    getSizeFileUploadsMB(realFiles) {
      let bytes = 0;
      realFiles.forEach((i) => {
        bytes = bytes + i.filesize;
      });
      return (bytes / (1024 * 1024)).toFixed(1);
    },
    calMarginTop() {
      var h = window.innerHeight;
      let defaultVal = 40;
      if (h < 800) defaultVal = defaultVal - 25;
      if (this.docList.length != 0) {
        defaultVal = defaultVal - 5 * this.docList.length;
      }
      if (defaultVal < 0) return 0;
      return defaultVal;
    },
  },
};
</script>

<style>
a {
  color: black;
  text-decoration: none;
}

a:hover,
a:focus {
  color: black;
  text-decoration: none;
}

.deviate-text {
  color: #ff6961;
  font-size: 0.75rem;
}

.document-info>.title {
  color: #00a3e4;
}

.document-info>.header {
  color: #000000;
}

.document-info>.body {
  color: #8e94a4;
}

.btn-upload-true {
  background-color: #e3e4e8 !important;
  color: #aaafbb !important;
  border-color: #e3e4e8 !important;
}

.btn-ktb-deviate {
  background-color: white !important;
  color: #df0747 !important;
  border-color: #f93972 !important;
}

.btn-goback {
  background-color: white !important;
  color: #00a3e4 !important;
  border-color: #00a3e4 !important;
}

.text-upload-true {
  color: #aaafbb !important;
}

.alert-warning {
  color: #b98f13;
  background-color: #fdf8e7;
  border-color: #ffeeba;
  border-left-color: #f5d470;
  border-left-width: 4px;
}

.spin {
  animation-name: spin;
  animation-duration: 5000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.status-color-2 {
  color: #daa60b !important;
}

.status-color-3 {
  color: #479e6a !important;
}

.status-color-6 {
  color: #aaafbb !important;
}

.status-color-5,
.status-color-1,
.status-color-4 {
  color: #df0747 !important;
}

.text-right {
  text-align: right;
}

.text-wait-upload {
  color: #e4ba00;
}

.text-upload {
  color: rgb(99, 190, 0);
}

.text-upload-error {
  color: rgb(219, 0, 0);
}

.header-group-doc {
  font-size: 20px;
}

.body-landing {
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>